/*Analytics*/
analytics.eventConfig.push(
    {
        "target": ".component.ProductApplications",
        "codeId": "a24",
        "events": [
            {
                "eventTarget": ".product-application-table a",
                "eventType": "click",
                "tags": {
                    "componentId": "a24",
                    "componentName": "product applications",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product applications link",
                    "event": "navigation",
                    "eventType": "product applications internal navigation click",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "a"
                    },
                    "listSource": "",
                    "titleText": ""
                }
            }
        ]
    }
)